import API from "./axios";

// Fetch bounded API batches in sequence. Each batch updates the screen so it
// can render promptly while the remaining records continue loading.
export async function fetchPagedCollection(resource, onProgress, pageSize = 50) {
  const first = await API.get(`${resource}/page`, {
    params: { page: 0, size: pageSize },
  });
  const rows = [...(first.data.content || [])];
  onProgress?.(rows, first.data);

  // The UI still needs the complete collection for its existing cross-page
  // filters and summary chips. Fetch later pages in small concurrent groups
  // so one slow request does not serialize every subsequent batch. Keep pages
  // in server order before publishing each progressive snapshot.
  const concurrency = 3;
  for (let start = 1; start < first.data.totalPages; start += concurrency) {
    const pageNumbers = Array.from(
      { length: Math.min(concurrency, first.data.totalPages - start) },
      (_, index) => start + index,
    );
    const responses = await Promise.all(
      pageNumbers.map((page) =>
        API.get(`${resource}/page`, { params: { page, size: pageSize } }),
      ),
    );
    responses.forEach((response) => {
      rows.push(...(response.data.content || []));
    });
    onProgress?.([...rows], responses[responses.length - 1]?.data);
  }
  return rows;
}
